import { UserCenterService } from "@/utils/axios";

export const userCenterApi = {
  GetAllWithoutToken: "/api/public/api/services/app/User/GetAll", // 获取用户信息（无需token）
  GetTokenBySerialNo: "/api/public/getTokenBySerialNo", // 根据serialNo获取token
  GetAll: "/api/services/app/User/GetAll", // 用户信息
  GetAUser: "/api/services/app/User/Get", // 用户信息
  ALogin: "/api/TokenAuth/Authenticate", // A平台登录
  ValidNameOrEmail: "/api/services/app/Account/ValidNameOrEmail", // 验证字段
  Register: "/api/services/app/Account/Register", // 提交 用户+公司数据
  sendCode: "/api/services/app/Account/SendAliSmsAsync/v2", // 发送验证码
  tenantGetAll: "/api/services/app/Tenant/GetAll", // 租户信息
  userAuditRecord: {
    createOrUpdate: "/api/services/app/userAuditRecord/CreateOrUpdate",
  },
  AbpCompanyGetPaged: "/api/services/app/AbpCompany/GetPaged", // 公司信息
};

export function userCenterGetAllWithoutToken(params, headers) {
  return UserCenterService({
    url: userCenterApi.GetAllWithoutToken,
    method: "get",
    params,
    headers,
  });
}

export function userCenterGetTokenBySerialNo(params, headers) {
  return UserCenterService({
    url: userCenterApi.GetTokenBySerialNo,
    method: "get",
    params,
    headers,
  });
}

export function userCenterGetAll(params, headers) {
  return UserCenterService({
    url: userCenterApi.GetAll,
    method: "get",
    params,
    headers,
  });
}

export function userCenterGetAUser(params, headers) {
  return UserCenterService({
    url: userCenterApi.GetAUser,
    method: "get",
    params,
    headers,
  });
}

export function userCenterALogin(params, headers) {
  return UserCenterService({
    url: userCenterApi.ALogin,
    method: "post",
    headers,
    data: params,
  });
}

export function userCenterValidNameOrEmail(data) {
  return UserCenterService({
    url: userCenterApi.ValidNameOrEmail,
    method: "post",
    data,
  });
}

export function userCenterRegister(data, headers) {
  return UserCenterService({
    url: userCenterApi.Register,
    method: "post",
    data,
    headers,
  });
}

export function userCenterSendCode(data) {
  return UserCenterService({
    url: userCenterApi.sendCode,
    method: "post",
    data,
  });
}

/** ***************** 用户审核记录表 *************** */
export function userAuditRecordCreateOrUpdate(data, headers) {
  return UserCenterService({
    url: userCenterApi.userAuditRecord.createOrUpdate,
    method: "post",
    data,
    headers,
  });
}
/** ***************** 用户审核记录表 *************** */

export function AbpCompanyGetPaged(params) {
  return UserCenterService({
    url: userCenterApi.AbpCompanyGetPaged,
    method: "get",
    params,
  });
}
